var React = require('react');

function VietnamRound (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"vietnam-round"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"id":"vietnam-round","fillRule":"nonzero"},[React.createElement("circle",{"id":"Oval","fill":"#D80027","cx":"8","cy":"8","r":"8","key":0}),React.createElement("polygon",{"id":"Path","fill":"#FFDA44","points":"8 4.17390625 8.863375 6.8310625 11.6572813 6.8310625 9.3969375 8.47325 10.2603125 11.1304375 8 9.48821875 5.7396875 11.1304375 6.6030625 8.47325 4.34275 6.8310625 7.136625 6.8310625","key":1})]))]);
}

VietnamRound.defaultProps = {"width":"16px","height":"16px","viewBox":"0 0 16 16","version":"1.1"};

module.exports = VietnamRound;

VietnamRound.default = VietnamRound;
